module.exports = __webpack_public_path__ + "static/Costco_Logo-13a67e835421708a70b795a72011046c.png";